export default "__VITE_ASSET__Cev2a066__"